import React, { useCallback } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { JSMABridge } from '@indeed/jsma-js-bridge';
import { Box, Flex } from '@indeed/ifl-components';
import MidSetupFeedbackCategoryStep from './MidSetupFeedbackCategoryStep';
import MidSetupFeedbackDetailsStep from './MidSetupFeedbackDetailsStep';
import { useApplyForMeCopy } from '../hooks/useApplyForMeCopy';
import { usePageFlow } from '../../../lib/pageFlow';

const MidSetupFeedbackPage: React.FC = () => {
    const { exitSubFlow } = usePageFlow();
    const copy = useApplyForMeCopy();

    const handleClose = useCallback(() => {
        if (JSMABridge.isAvailable()) {
            void JSMABridge.dismissModalWithWebView({});
        } else {
            // Exit the feedback sub-flow by popping the whole detour (category +
            // details) back to its origin. enterSubFlow recorded the originating
            // setup step as the sub-flow origin, and the pop restores its full URL
            // (incl. params like indeedApplyableJobId), so we only need a static
            // fallback for the (non-real on web) cold-start case. See IAFE-383.
            void exitSubFlow('/auto-apply-setup');
        }
    }, [exitSubFlow]);

    return (
        <Flex
            sx={{
                inlineSize: '100%',
                justifyContent: 'center',
            }}
        >
            <Box
                sx={{
                    inlineSize: '100%',
                    maxInlineSize: '25.125rem',
                    paddingInline: 4,
                }}
            >
                <Helmet>
                    <title>{copy.midSetupFeedbackTitle}</title>
                    <meta name="description" content={copy.midSetupFeedbackMetaDescription} />
                </Helmet>
                <Routes>
                    <Route index element={<MidSetupFeedbackCategoryStep onClose={handleClose} />} />
                    <Route
                        path=":category"
                        element={<MidSetupFeedbackDetailsStep onClose={handleClose} />}
                    />
                </Routes>
            </Box>
        </Flex>
    );
};

export default MidSetupFeedbackPage;
